import React from 'react';

const EmailCheckIcon = () => {
    return (
        <svg width="122" height="115" viewBox="0 0 122 115" fill="none" xmlns="http://www.w3.org/2000/svg">
            <path d="M66.0834 91.0391C66.0834 75.1786 79.7575 62.2891 96.5834 62.2891C102.175 62.2891 107.36 63.7266 111.833 66.1703V28.7474C111.833 26.2057 110.762 23.7682 108.856 21.971C106.949 20.1737 104.363 19.1641 101.667 19.1641H20.3334C14.6909 19.1641 10.1667 23.4286 10.1667 28.7474V86.2474C10.1667 88.7891 11.2378 91.2266 13.1444 93.0238C15.0511 94.8211 17.637 95.8307 20.3334 95.8307H66.5409C66.2867 94.2495 66.0834 92.6682 66.0834 91.0391ZM20.3334 38.3307V28.7474L61 52.7057L101.667 28.7474V38.3307L61 62.2891L20.3334 38.3307ZM90.2292 106.181L76.25 91.8057L82.1467 86.2474L90.2292 93.8661L108.478 76.6641L114.375 83.4203L90.2292 106.181Z" fill="#D2B2FF" />
        </svg>
    );
};

export default EmailCheckIcon;
